module.exports = __webpack_public_path__ + "96675d189c25d7bfb856a4ac0f93aa90.MP3";